import { useTranslation } from 'react-i18next';
import './lang-picker.scss';

type TProps = {
    className?: string;
    onChange?: (lang: string) => void;
}

const langs: { id: 'ru' | 'kz' | 'en'; label: string }[] = [
    { id: 'ru', label: 'Рус' },
    { id: 'kz', label: 'Қаз' },
    { id: 'en', label: 'Eng' },
];

export const LangPicker = ({ className = '', onChange }: TProps) => {
    const { i18n } = useTranslation();

    const handleClick = (lang: string) => {
        i18n.changeLanguage(lang);
        onChange?.(lang);
    };

    return (
        <div className={`vb-lang-picker ${className}`}>
            {langs.map((lang) => (
                <button
                    key={`lang-picker-${lang.id}`}
                    className={`vb-lang-picker__item ${i18n.language === lang.id ? 'vb-lang-picker__item--active' : ''}`}
                    onClick={() => handleClick(lang.id)}
                >
                    {lang.label}
                </button>
            ))}
        </div>
    );
};
